<template>
  <template v-for="menu in menus" :key="menu.id">
    <!-- 如果有子菜单，渲染为 SubMenu -->
    <a-sub-menu v-if="menu.children && menu.children.length > 0" :key="menu.permissionKey">
      <template #icon>
        <component :is="getIconComponent(menu.icon)" />
      </template>
      <template #title>{{ menu.name }}</template>
      <!-- 递归渲染子菜单 -->
      <DynamicMenu :menus="menu.children" />
    </a-sub-menu>

    <!-- 如果没有子菜单，渲染为 MenuItem -->
    <a-menu-item v-else :key="menu.path">
      <template #icon v-if="menu.icon">
        <component :is="getIconComponent(menu.icon)" />
      </template>
      {{ menu.name }}
    </a-menu-item>
  </template>
</template>

<script>
import { defineComponent } from 'vue'
import {
  DashboardOutlined,
  ShopOutlined,
  DatabaseOutlined,
  AccountBookOutlined,
  SettingOutlined,
  FactoryOutlined,
  UserOutlined,
  TeamOutlined,
  SafetyOutlined
} from '@ant-design/icons-vue'

export default defineComponent({
  name: 'DynamicMenu',
  props: {
    menus: {
      type: Array,
      default: () => []
    }
  },
  setup() {
    // 图标映射
    const iconMap = {
      'dashboard': DashboardOutlined,
      'goods': ShopOutlined,
      'shop': ShopOutlined,
      'database': DatabaseOutlined,
      'stock': DatabaseOutlined,
      'account-book': AccountBookOutlined,
      'financial': AccountBookOutlined,
      'setting': SettingOutlined,
      'factory': FactoryOutlined,
      'user': UserOutlined,
      'team': TeamOutlined,
      'safety': SafetyOutlined
    }

    const getIconComponent = (iconName) => {
      if (!iconName) return DashboardOutlined
      return iconMap[iconName] || DashboardOutlined
    }

    return {
      getIconComponent
    }
  }
})
</script>
